import React, { Component } from "react";
import axios from "axios";
import { Image } from "@sketchpixy/rubix";

export class MoreDocsModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isExist: false,
      isLoading: true,
      docsArray: [],
      patientId: "",
      isLoadingDoc: false,
    };
  }

  componentDidMount() {
    let patientId =
      (sessionStorage.getItem("patient") &&
        JSON.parse(sessionStorage.getItem("patient")).id) ||
      "";

    if(patientId === "") {
      patientId = (sessionStorage.getItem("pDoc") &&
          JSON.parse(sessionStorage.getItem("pDoc")).patientId) ||
        "";
    }

    const url = `${process.env.API_URL}/patients/show-network-documents/${patientId}`;
    const token = localStorage.getItem("login_token");
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    };

    axios
      .get(url, { headers })
      .then(async (response) => {
        this.setState({
          isExist: true,
          isLoading: false,
          patientId: patientId,
          docsArray: response.data.records,
        });
      })
      .catch((e) => {
        this.setState({
          isExist: false,
          isLoading: false,
          patientId: patientId,
        });
      });
  }

  getDocumentFromBox = async (docId) => {
    const url = `${process.env.API_URL}/patients/view-show-network-document/${docId}`;
    const token = localStorage.getItem("login_token");
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    };

    return await axios.get(url, { headers, responseType: 'blob' });
  };

  handleFileOpen = async (boxId) => {
    this.setState({
      isLoadingDoc: true,
    });
    try {
      const response = await this.getDocumentFromBox(boxId);
      const fileBlob = new Blob([response.data], {
        type: response.headers['content-type'],
      });
      const fileURL = URL.createObjectURL(fileBlob);
      window.open(fileURL, '_blank');
      URL.revokeObjectURL(fileURL);
    } catch (error) {
      this.setState({
        isLoadingDoc: false,
      });

      if (error.response.status === 403) {
        alert('Access to this file is no longer available. Please open the modal again to refresh your access.');
      } else {
        alert('Error downloading file.');
      }
    } finally {
      this.setState({
        isLoadingDoc: false,
      });
    }
  };

  render() {
    const { onClose } = this.props;

    return (
      <div
        className="overlay-msg"
        onClick={(e) => {
          onClose(e);
        }}
      >
        <div className="overlay-box modal-relative" onClick={(e) => {
            e.stopPropagation();
          }}>
            {this.state.isExist && <button
                className="close-btn"
                onClick={(e) => {
                  e.stopPropagation();
                  onClose(e);
                }}
              >
                &times;
              </button>
            }
            
          <div className="row">
            {this.state.isLoadingDoc && (
              <div className="loader-container">
                <Image src="/imgs/app/loading.gif" className="loader-img"/>
              </div>
            )}
            {this.state.isLoading ? (
              <div style={{ color: "#F12F39" }}>
                <h1>Loading files...</h1>
              </div>
            ) : this.state.isExist ? (
              <div className="docs-list">
                <h2>Additional Documents:</h2>
                <ul>
                  {this.state.docsArray.map((doc) => (
                    <li key={doc.Id} className="doc-item">
                      <a
                        onClick={() => this.handleFileOpen(doc.Id)}
                        className="doc-link"
                      >
                        {doc.Document_Name__c} - {doc.Required_Documents__c}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            ) : (
              <div style={{ color: "#F12F39" }}>
                <h1>No more additional files are available.</h1>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}